import { parseISO } from 'date-fns'
import { Icon, InlineTag, TooltipWrapper } from '../../../shared'
import { getV3ColorCssVariable } from '../../../../design-system/colors_v3'
import { formatFr, isValidDate } from '../../../../misc/date.utilities'
import { PatientInfosItemEditableProps } from './PatientInfosItemEditable.model'
import { addTestIdSuffix } from '../../../../misc/testId.utilities'
import styles from './PatientInfosItemEditable.module.scss'

/**
 * Can be used to display patient informations
 * (Treatments, Allergies)
 */
export const PatientInfosItemEditable = ({
  name,
  title,
  tags,
  startDate,
  endDate,
  actions,
  prescriber,
  testId,
}: PatientInfosItemEditableProps) => {
  return (
    <div
      className={styles.patientInfosItemEditableContainer}
      data-test-id={addTestIdSuffix('root', testId)}
    >
      <div className={styles.patientInfosItemEditableInfosWithActions}>
        <div className={styles.patientInfosItemEditableInfosContainer}>
          {tags && (
            <div className={styles.patientInfosItemEditableLabelWithTags}>
              {tags.map((tag, index) => (
                <TooltipWrapper
                  key={index}
                  content={tag.info ?? ''}
                  display={tag.info !== undefined}
                  size="small"
                >
                  <InlineTag color={tag.color}>{tag.name}</InlineTag>
                </TooltipWrapper>
              ))}
            </div>
          )}
          <TooltipWrapper content={title ?? ''} display={!!title}>
            <span>{name}</span>
          </TooltipWrapper>
        </div>
        <div className={styles.patientInfosItemEditableActionsContainer}>{actions}</div>
      </div>
      {prescriber && <span className={styles.patientInfosItemPrescriber}>{prescriber}</span>}
      {(startDate || endDate) && (
        <div className={styles.patientInfosItemDates}>
          {startDate && isValidDate(startDate) && (
            <>
              <Icon icon="calendar" size="nano" color={getV3ColorCssVariable('shades', 'shade4')} />
              <span>
                {formatFr(
                  typeof startDate === 'string' ? parseISO(startDate) : startDate,
                  'dd/MM/yyyy',
                )}
              </span>
            </>
          )}
          {endDate && isValidDate(endDate) && (
            <>
              <Icon
                icon="arrow"
                rotate={90}
                size="nano"
                color={getV3ColorCssVariable('shades', 'shade4')}
              />
              <Icon icon="calendar" size="nano" color={getV3ColorCssVariable('shades', 'shade4')} />
              <span>
                {formatFr(typeof endDate === 'string' ? parseISO(endDate) : endDate, 'dd/MM/yyyy')}
              </span>
            </>
          )}
        </div>
      )}
    </div>
  )
}
